import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { ToastContainer } from "react-toastify";
import jwtDecode from "jwt-decode";
import { ThemeProvider } from "styled-components";
import useUserInfo from "../../hooks/queryResults/useUserInfo";
import useAdminMode from "../../hooks/useAdminMode";
import useCurrentUser from "../../hooks/useCurrentUser";
import { runTimeSetup } from "../../store/slices/time";
import { useThemeToggle } from "../layout/hooks/useThemeToggle";
import Footer from "../layout/Footer";
import Factory from "../../classes/factory";
import BREAKPOINTS from "../../constants/breakpoints";
import BreakpointContext from "../../contexts/breakpointContext";
import UserInfoContext from "../../contexts/userInfoContext";
import Breakpoints from "../../style/breakpoints";
import GlobalStyle from "../../style/global";
import FactoryContext from "../../contexts/factoryContext";
import "react-toastify/dist/ReactToastify.css";
import {
  logUserIn,
  logUserOut,
  toggleAdminModeOn,
} from "../../store/slices/auth";
import Routes from "./Routes";

function App() {
  const location = useLocation();
  const dispatch = useDispatch();

  const { userInfoQuery } = useUserInfo();
  const currentUser = useCurrentUser();
  const adminMode = useAdminMode();
  const [theme, themeName, changeTheme, componentMounted] = useThemeToggle();

  const [factory, setFactory] = useState(new Factory(null));

  useEffect(() => {
    dispatch(runTimeSetup());

    try {
      const token = localStorage.getItem("token");
      if (token && token !== "undefined") {
        const data = { ...jwtDecode(token) };
        dispatch(logUserIn(data));
        console.log("logged in from token", data);
      }
    } catch (ex) {
      dispatch(logUserOut());
    }

    if (userInfoQuery.data) {
      if (!factory.userInfo) setFactory(new Factory(userInfoQuery.data));
    }
  }, [userInfoQuery.data, factory, location, dispatch]);

  useEffect(() => {
    const adminModeUsername = localStorage.getItem("adminMode");

    if (
      !adminMode &&
      currentUser.obj.isLoggedIn &&
      currentUser.isAdmin() &&
      adminModeUsername &&
      adminModeUsername === currentUser.obj.username
    ) {
      dispatch(toggleAdminModeOn());
    }
  }, [currentUser, adminMode, dispatch]);

  const breakpoints = new Breakpoints({
    xs: useMediaQuery({ minWidth: 0 }),
    sm: useMediaQuery({ minWidth: BREAKPOINTS.sm }),
    md: useMediaQuery({ minWidth: BREAKPOINTS.md }),
    lg: useMediaQuery({ minWidth: BREAKPOINTS.lg }),
    xl: useMediaQuery({ minWidth: BREAKPOINTS.xl }),
  });

  if (!componentMounted) return <div />;

  return (
    <UserInfoContext.Provider value={userInfoQuery}>
      <FactoryContext.Provider value={factory}>
        <ToastContainer />
        <ThemeProvider theme={theme}>
          <GlobalStyle />
          <BreakpointContext.Provider value={breakpoints}>
            <div className={"content"}>
              <Routes />
            </div>
            <Footer themeName={themeName} changeTheme={changeTheme} />
          </BreakpointContext.Provider>
        </ThemeProvider>
      </FactoryContext.Provider>
    </UserInfoContext.Provider>
  );
}

export default App;
